<template>
  <div class="container">
    <section class="header">
      <nav class="nav">
        <router-link to="/">
          <a href="#" class="logo">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="177"
              height="29.944"
              viewBox="0 0 177 29.944"
            >
              <g transform="translate(-478.85 106.927)">
                <g transform="translate(478.85 -106.927)">
                  <g>
                    <path
                      d="M490.888-81.862a7.169,7.169,0,0,1-7.162-7.16v-8.155h2.687v8.155a4.481,4.481,0,0,0,4.475,4.476,4.481,4.481,0,0,0,4.475-4.476V-99.364H478.85v-7.563h24.077v2.686H481.537v2.192H498.05v13.027A7.169,7.169,0,0,1,490.888-81.862Z"
                      transform="translate(-478.85 106.927)"
                    />
                  </g>
                  <g transform="translate(0 4.879)">
                    <path
                      d="M490.888-77.249A12.054,12.054,0,0,1,478.85-89.287v-8.155h2.687v8.155a9.361,9.361,0,0,0,9.35,9.351,9.363,9.363,0,0,0,9.351-9.351v-13.027h2.687v13.027A12.054,12.054,0,0,1,490.888-77.249Z"
                      transform="translate(-478.85 102.314)"
                    />
                  </g>
                </g>
                <g transform="translate(511.969 -100.868)">
                  <path
                    d="M512.31-84.306a8.4,8.4,0,0,1-2.145-6.183v-10.459h3.441v10.327q0,5.456,4.713,5.455,4.686,0,4.687-5.455v-10.327H526.4v10.459a8.429,8.429,0,0,1-2.131,6.183,8.012,8.012,0,0,1-5.97,2.158A8.054,8.054,0,0,1,512.31-84.306Z"
                    transform="translate(-510.165 101.212)"
                  />
                  <path
                    d="M546.577-100.153a6.1,6.1,0,0,1,2.74,2.277,6.368,6.368,0,0,1,.953,3.521,6.388,6.388,0,0,1-.953,3.509,6.077,6.077,0,0,1-2.74,2.29,10.262,10.262,0,0,1-4.2.794H538.2v5.348h-3.443v-18.535h7.625A10.262,10.262,0,0,1,546.577-100.153Zm-.94,8.525a3.323,3.323,0,0,0,1.164-2.728,3.322,3.322,0,0,0-1.164-2.727,5.29,5.29,0,0,0-3.416-.953H538.2v7.36h4.024A5.29,5.29,0,0,0,545.637-91.627Z"
                    transform="translate(-508.748 101.212)"
                  />
                  <path
                    d="M559.393-82.743a8.648,8.648,0,0,1-3.163-1.615l1.191-2.675a9.373,9.373,0,0,0,2.794,1.47,10.144,10.144,0,0,0,3.322.569,5.745,5.745,0,0,0,3.085-.662,2.006,2.006,0,0,0,1.019-1.747,1.7,1.7,0,0,0-.569-1.311,4,4,0,0,0-1.444-.807q-.874-.292-2.383-.662a27.788,27.788,0,0,1-3.429-1.006,5.639,5.639,0,0,1-2.25-1.576,4.241,4.241,0,0,1-.94-2.9,4.948,4.948,0,0,1,.834-2.794,5.653,5.653,0,0,1,2.515-2,10.2,10.2,0,0,1,4.117-.741,13.313,13.313,0,0,1,3.337.424,9.215,9.215,0,0,1,2.832,1.217l-1.085,2.675a10.754,10.754,0,0,0-2.543-1.086,9.53,9.53,0,0,0-2.568-.37,5.367,5.367,0,0,0-3.032.689,2.125,2.125,0,0,0-.992,1.826,1.651,1.651,0,0,0,.569,1.3,4.111,4.111,0,0,0,1.443.794q.874.292,2.384.662a25.127,25.127,0,0,1,3.388.993,5.805,5.805,0,0,1,2.264,1.575,4.155,4.155,0,0,1,.939,2.86,4.888,4.888,0,0,1-.833,2.78,5.67,5.67,0,0,1-2.529,1.986,10.294,10.294,0,0,1-4.131.74A14.139,14.139,0,0,1,559.393-82.743Z"
                    transform="translate(-507.511 101.198)"
                  />
                  <path
                    d="M584.717-90.171l-2.938,3.018v4.739h-3.443v-18.535h3.443v9.506l9.16-9.506h3.867l-7.785,8.289,8.261,10.246h-4.024Z"
                    transform="translate(-506.237 101.212)"
                  />
                  <path
                    d="M601.453-100.948H604.9v18.535h-3.443Z"
                    transform="translate(-504.906 101.212)"
                  />
                  <path
                    d="M614.093-100.948h3.443v15.623h9.691v2.912H614.093Z"
                    transform="translate(-504.177 101.212)"
                  />
                  <path
                    d="M633.791-100.948h3.443v15.623h9.69v2.912H633.791Z"
                    transform="translate(-503.043 101.212)"
                  />
                </g>
              </g>
            </svg>
          </a>
        </router-link>
        <span
          id="nav-toggle"
          class="nav-toggle"
          :class="{ opened }"
          @click="clickMobileMenu"
        ></span>
        <ul id="nav" :class="{ show }">
          <li v-for="item in routelinks" :key="item.name">
            <router-link :to="item.link" id="nav-item">{{
              item.name
            }}</router-link>
          </li>
          <li class="sign-in" v-if="!userLoggedIn">
            <i style="padding-right: 6px; color:  #007bff"></i>
            <a
              @click="Goto({ name: 'login' })"
              class="hover"
              style="color: #007bff;"
              >Sign in</a
            >
          </li>
          <li class="sign-in" v-else>
            <strong style="color: #0062ff"
              ><i class="fa fa-user-circle-o fa-2x"></i>
              {{ userInfo.name }}</strong
            >,
            <a @click="logout" class="hover sign">Sign out</a>
          </li>

          <!--  Singup button -->

          <li class="sign-up" v-if="!userLoggedIn">
            <a href="/signup" class="hover" style="color: #007bff;">Sign up</a>
          </li>
        </ul>
      </nav>
    </section>
  </div>
</template>

<script>
export default {
  data: () => {
    return {
      show: false,
      opened: false,
      userInfo: '',
      userLoggedIn: false,
      routelinks: [
        { name: 'Home', link: '/' },
        { name: 'Training', link: '/workshop' },
        // { name: "Consultancy", link: "/consultancy" },
        { name: 'Video Lessons', link: '/library' },
        // { name: "Corporate Training", link: "/corporate_training" },
        { name: 'FAQ', link: '/faq' },
        { name: 'Blog', link: '/blog' },
        { name: 'Earn With Upskill', link: '/host_workshop' },
        // { name: "Classroom", link: "/classroom" }
        // { name: "Message", link: "/message" }
      ],
      home: [],
    }
  },
  methods: {
    clickMobileMenu() {
      this.opened = !this.opened
      this.show = !this.show
    },
    logout() {
      this.Logout()
      this.userLoggedIn = false
    },
  },
  created() {
    if (this.SignedIn()) {
      let hasUserInfo = localStorage.getItem('userInfo')
      if (hasUserInfo) {
        this.userInfo = JSON.parse(hasUserInfo)
        this.userLoggedIn = true
      } else {
        this.$upskill
          .tokenToUser()
          .then((res) => {
            let info = res.data
            this.userInfo = info
            this.userLoggedIn = true
            localStorage.setItem('userInfo', JSON.stringify(info))
          })
          // eslint-disable-next-line no-unused-vars
          .catch((err) => {
            this.RemoveToken()
          })
      }
      this.routelinks.push({ name: 'My Profile', link: '/profile' })
    } else {
      this.userLoggedIn = false
    }
  },
}
</script>
<style scoped>
#nav-item {
  font-weight: bold;
  font-family: 'Manrope';
  color: #626367;
}
#nav-item.router-link-exact-active {
  color: #007bff;
  cursor: pointer;
}
.icon {
  margin: 0;
  padding: 0;
}
.nav {
  max-width: 1300px;
}
.sign-up {
  background: #2465f3 0% 0% no-repeat padding-box;
  border-radius: 4px;
  padding: 12px 20px;
}
.sign-up a {
  color: white !important;
  font-weight: 700;
  text-transform: capitalize;
  letter-spacing: 0.5px;
}
.nav ul {
  align-items: center;
}
</style>
